export type GreetingPeriod = 'morning' | 'forenoon' | 'afternoon' | 'evening';

const MAX_GREETING_TICK_MS = 60_000;

/**
 * Local-time greeting buckets used by the staff and patient dashboards.
 * Morning lasts until 09:00; 09:00–12:00 is forenoon so a late-morning
 * visit is not "Godmorgen" and not yet "afternoon".
 */
export function greetingPeriod(now = new Date()): GreetingPeriod {
  const hour = now.getHours();
  if (hour < 9) return 'morning';
  if (hour < 12) return 'forenoon';
  if (hour < 18) return 'afternoon';
  return 'evening';
}

/** Milliseconds until the next greeting-period boundary (09:00, 12:00, 18:00, or midnight). */
export function msUntilNextGreetingBoundary(now = new Date()): number {
  const next = new Date(now.getTime());
  const hour = now.getHours();
  if (hour < 9) {
    next.setHours(9, 0, 0, 0);
  } else if (hour < 12) {
    next.setHours(12, 0, 0, 0);
  } else if (hour < 18) {
    next.setHours(18, 0, 0, 0);
  } else {
    next.setDate(next.getDate() + 1);
    next.setHours(0, 0, 0, 0);
  }
  return Math.max(1, next.getTime() - now.getTime());
}

/** Delay used to refresh an open dashboard greeting (next boundary, at most once a minute). */
export function greetingRefreshDelayMs(now = new Date()): number {
  return Math.min(msUntilNextGreetingBoundary(now), MAX_GREETING_TICK_MS);
}
